//import * as FileSystem from 'expo-file-system';

import * as path from 'path';
import * as FileSystem from 'fs';
import * as FileSystemPromises from 'fs/promises';

export const calculateDirectorySize = async (dir: string): Promise<number> => {
  
    let totalSize = 0;

    const dirInfo = await FileSystem.existsSync(dir) && FileSystem.lstatSync(dir).isDirectory();

    if (!dirInfo) {
      return 0;
    }
  
    const items = await FileSystemPromises.readdir(dir);

    for (const item of items) {
      const itemPath = `${dir}/${item}`;
      const itemIsDirectory = await FileSystem.existsSync(itemPath) && FileSystem.lstatSync(itemPath).isDirectory();

      if (itemIsDirectory) {
        totalSize += await calculateDirectorySize(itemPath);
      } else {     
        const itemInfo = await FileSystem.lstatSync(itemPath) as { size: number };
        totalSize += itemInfo.size ?? 0;
      }
    }
    return totalSize;
  };